import { AbstractControl, ValidationErrors } from '@angular/forms';

export function futureDateValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null; // Don't validate empty values to allow optional controls
  }

  const inputDate = new Date(control.value);
  const today = new Date();

  // Reset time part to compare only dates
  today.setHours(0, 0, 0, 0);
  // inputDate comes from date input which is usually YYYY-MM-DD, treated as UTC. 
  // We need to be careful with timezones.
  // However, usually we just want to ensure the input date is not strictly greater than today.
  // Let's create a date object from the input string in local time to be safe if it's just yyyy-mm-dd
  // But new Date('yyyy-mm-dd') acts as UTC. 
  // safer to just compare time values if we are sure about the input format.
  // The input type="date" value is YYYY-MM-DD.
  // If we do new Date(control.value + 'T00:00:00'), it will be local time.
  
  const dateParts = control.value.split('-');
  if (dateParts.length === 3) {
      const year = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1;
      const day = parseInt(dateParts[2], 10);
      const inputDateLocal = new Date(year, month, day);
      
      if (inputDateLocal > today) {
        return { futureDate: true };
      }
  } else {
     // Fallback if format is weird
      if (inputDate > today) {
          return { futureDate: true };
      }
  }

  return null;
}

export function todayValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }

  const dateParts = control.value.split('-');
  if (dateParts.length === 3) {
    const year = parseInt(dateParts[0], 10);
    const month = parseInt(dateParts[1], 10) - 1;
    const day = parseInt(dateParts[2], 10);
    const inputDateLocal = new Date(year, month, day);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // Comparar los timestamps para asegurar que sean exactamente el mismo día
    if (inputDateLocal.getTime() !== today.getTime()) {
      return { mustBeToday: true };
    }
  }

  return null;
}

export function maxTwoYearsAgoValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }

  const dateParts = control.value.split('-');
  if (dateParts.length === 3) {
    const year = parseInt(dateParts[0], 10);
    const month = parseInt(dateParts[1], 10) - 1;
    const day = parseInt(dateParts[2], 10);
    const inputDateLocal = new Date(year, month, day);

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const twoYearsAgo = new Date();
    twoYearsAgo.setHours(0, 0, 0, 0);
    twoYearsAgo.setFullYear(today.getFullYear() - 2);

    if (inputDateLocal < twoYearsAgo || inputDateLocal > today) {
      return { invalidDateRange: true };
    }
  }

  return null;
}
